import { render } from "./AiPoolUserChangesSection.vue?vue&type=template&id=f58960a0&scoped=true"
import script from "./AiPoolUserChangesSection.vue?vue&type=script&lang=js"
export * from "./AiPoolUserChangesSection.vue?vue&type=script&lang=js"

import "./AiPoolUserChangesSection.vue?vue&type=style&index=0&id=f58960a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58960a0"]])

export default __exports__